export type Tone = 'primary' | 'accent' | 'secondary';

export const toneChip: Record<Tone, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export const toneSolid: Record<Tone, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export const toneIconBg: Record<Tone, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};